module.exports = __webpack_public_path__ + "static/media/intro.cc784e91.mp3";